import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  usersPopup: {
    '& .popup__box': {
      maxWidth: 885,
      height: 315,
      overflow: 'unset !important',

      [theme.breakpoints.down('sm')]: {
        height: 455
      }
    },

    '& .popup__main': {
      marginTop: 32,
      overflowY: 'unset !important'
    },

    '& .containerButtons': {
      width: 'unset'
    },

    '& .footerPopup': {
      justifyContent: 'end'
    }
  },

  genotypingContainer: {
    height: '100%',
    position: 'relative',
    paddingRight: '16px'
  },

  genotypingHeaderContent: {
    width: '100%',
    display: 'flex',
    gap: 8,
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  genotypingHeaderBtnContainer: {
    display: 'flex',
    gap: 10,

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap',
      width: '100%',
      flexDirection: 'column'
    }
  },

  genotypingHeaderBtn: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'transparent',
    width: 118,
    height: 40,
    borderWidth: 1,
    borderRadius: 6,
    borderColor: theme.palette.primary.main,
    fontWeight: 800,
    color: theme.palette.primary.main,

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  genotypingContainerContent: {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',

    '&>*:nth-child(2)': {
      marginRight: 24,
      marginLeft: 24
    },

    '@media (max-width:767px)': {
      overflowX: 'scroll'
    }
  },

  genotypingStatusPending: {
    padding: 10,
    backgroundColor: '#5778EC',
    borderRadius: 4,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  genotypingStatusDone: {
    maxWidth: 91,
    padding: 10,
    backgroundColor: '#4BC599',
    borderRadius: 4,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  genotypingStatusText: {
    width: 110,
    color: '#fff'
  },

  genotypingContainerContentData: {
    height: '100%',
    position: 'relative',
    paddingRight: 16
  },

  genotypingDivider: {
    width: 'calc(100% - 293px)',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  genotypingTableActions: {
    width: '100%',
    display: 'flex',
    height: 5,
    '& img': {
      cursor: 'pointer'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-around'
    }
  },
  genotypingHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    paddingRight: 16,
    '@media (min-width:356px)': {
      paddingRight: 16,
      display: 'inline-flex'
    }
  },

  genotypingTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  genotypingSubTitle: {
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500
  },
  genotypingDividerSubTitle: {
    height: 1,
    width: '100%',
    backgroundColor: '#E5E5E5'
  },

  genotypingButtonContainer: {
    marginLeft: 'auto',
    width: '100%',
    '& h1': {
      margin: '0 16px 0 0',
      cursor: 'pointer'
    },

    '@media (min-width:356px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      }
    }
  },

  genotypingPopup: {
    '& .popup__box': {
      height: '80vh'
    }
  },

  filterContainer: {
    '& .containerButtons': {
      display: 'flex',
      gap: '20px',
      marginBottom: '20px'
    }
  }
}))
